export enum CategoryType {
  NEWS = 'news',
  PRODUCT = 'product',
  BOTH = 'both',
  GALLERY = 'gallery'
}
